module.exports = __webpack_public_path__ + "img/banner.5eade6e7.png";